import { isEmpty } from 'lodash';
import React, { Dispatch, SetStateAction } from 'react';
import { Reference as NoteReference } from 'sr-types/lib/note/v1/graphql';
import { Note, Production } from 'sr-types/lib/search/v1/graphql';
import { EntitySecurityProvider } from '../../../common/auth/Security';
import Loading from '../../../common/components/Loading';
import { SIDE_PANEL_IDS } from '../../../common/constants/constants';
import { ENTITY_CONSTANTS } from '../../../common/constants/entityConstants';
import { H } from '../../../common/Layout';
import { ProductionTypeSuperset } from '../../helpers/productionApi';
import ProductionStatusNoteAddButton from './ProductionStatusNoteAddButton';
import ProductionStatusNoteDisplay from './ProductionStatusNoteDisplay';

type ProductionStatusNoteProps = {
    workspace: ProductionTypeSuperset;
    currentStatusNoteReference?: NoteReference;
    currentStatusNote?: Note;
    statusNote: {
        enableCurrentNote?: boolean;
        onCurrentNoteClick?: (row: Production, panelId: string, note: Note, isStatusNoteAction: boolean) => void;
        onStatusNoteDeleted?: (noteId: string, productionId: string) => void;
        onStatusNoteChanged?: (note: Note | null, productionId: string) => void;
    };
    setExpandNoteSection?: Dispatch<SetStateAction<boolean>>;
    isLoading?: boolean;
};

const ProductionStatusNote = ({
    currentStatusNoteReference,
    currentStatusNote,
    workspace,
    statusNote,
    setExpandNoteSection,
    isLoading = false
}: ProductionStatusNoteProps) => {
    const {
        enableCurrentNote = false,
        onCurrentNoteClick = undefined,
        onStatusNoteDeleted = undefined,
        onStatusNoteChanged = undefined
    } = statusNote || {};

    const isCurrentNoteEmpty = !currentStatusNote || isEmpty(currentStatusNote);
    const isCurrentStatusNoteDeleted = currentStatusNoteReference?.deleted;

    const showStatusNote =
        enableCurrentNote &&
        currentStatusNoteReference?.id &&
        !isCurrentStatusNoteDeleted &&
        !isCurrentNoteEmpty &&
        !isLoading;

    const handleCurrentNoteClicked = ({ isCreateNewNote }: { isCreateNewNote: boolean }) => {
        onCurrentNoteClick?.(workspace, SIDE_PANEL_IDS.notes, isCreateNewNote ? null : currentStatusNote, true);
    };

    if (isLoading) {
        return <Loading />;
    }

    return (
        <EntitySecurityProvider entityName={ENTITY_CONSTANTS.note} entitySecurity={currentStatusNote?.security}>
            {showStatusNote && (
                <ProductionStatusNoteDisplay
                    note={currentStatusNote}
                    productionReference={workspace.reference}
                    onStatusNoteDeleted={onStatusNoteDeleted}
                    onStatusNoteChanged={onStatusNoteChanged}
                    setExpandNoteSection={setExpandNoteSection}
                    onNewStatusNoteClick={handleCurrentNoteClicked}
                />
            )}

            {enableCurrentNote && !showStatusNote && (
                <H sx={{ justifyContent: 'center' }}>
                    <ProductionStatusNoteAddButton
                        onClick={() => handleCurrentNoteClicked({ isCreateNewNote: true })}
                    />
                </H>
            )}
        </EntitySecurityProvider>
    );
};

export default ProductionStatusNote;
